import {createStrokeSVG} from './TEMPLATE'

// tabler: external-link
export const SquareArrowTopRight_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6',
    'M11 13l9 -9',
    'M15 4h5v5',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
